import React from 'react';
import { observer } from 'mobx-react';
import { BasePath } from 'services/base/page_path';
import { APP_VERSION } from 'services/base/config';
import { Link } from 'ui/base/link';
import { Theme, ThemedStyles, useStyles } from 'ui/base/theme';
import { CenteredPublicPage } from 'ui/base/page/public_page/public_page';
import { ActiveButton, DefaultButton } from 'ui/public/button';
import baseStyles from './introduction.module.css';
import IntroductionMessages from './introduction_messages';
import logoFull from './assets/pangolin_logo_full.png';
import { LocaleSelector } from 'ui/standard/search/locale_selector/locale_selector';


type IntroductionStyles = {
  taglineText: string;
  layout: string;
  body: string;
  logoFull: string;
  logoText: string;
  buttonLink: string;
  link: string;
  footer: string;
  localeSelectorContainer: string;
  version: string;
};

const themedStyles: ThemedStyles<IntroductionStyles> = {
  [Theme.DAYLIGHT]: {
    taglineText: baseStyles.daylightTaglineText,
    layout: baseStyles.baseLayout,
    body: baseStyles.baseBody,
    logoFull: baseStyles.baseLogoFull,
    logoText: baseStyles.daylightLogoText,
    buttonLink: baseStyles.baseButtonLink,
    link: baseStyles.baseLink,
    footer: baseStyles.baseFooter,
    localeSelectorContainer: baseStyles.localeSelectorContainer,
    version: baseStyles.version,
  },
  [Theme.MIDNIGHT]: {
    taglineText: baseStyles.midnightTaglineText,
    layout: baseStyles.baseLayout,
    body: baseStyles.baseBody,
    logoFull: baseStyles.baseLogoFull,
    logoText: baseStyles.midnightLogoText,
    buttonLink: baseStyles.baseButtonLink,
    link: baseStyles.baseLink,
    footer: baseStyles.baseFooter,
    localeSelectorContainer: baseStyles.localeSelectorContainer,
    version: baseStyles.version,
  },
};

export const Introduction = observer(() => {
  const styles = useStyles(themedStyles);
  return (
    <CenteredPublicPage>
      <div className={styles.layout}>
        <div className={styles.body}>
          <div>
            <img src={logoFull} className={styles.logoFull} alt='logoFull' />
          </div>
          <div className={styles.logoText}/>
          <div className={styles.taglineText}>
            {IntroductionMessages.smartFirewall()}
          </div>
          <Link path={{ kind: BasePath.REGISTER }} className={styles.link}>
            <ActiveButton className={styles.buttonLink}>
              {IntroductionMessages.register()}
            </ActiveButton>
          </Link>
          <Link path={{ kind: BasePath.LOGIN }} className={styles.link}>
            <DefaultButton className={styles.buttonLink}>
              {IntroductionMessages.login()}
            </DefaultButton>
          </Link>
        </div>
        <div className={styles.footer}>
          <LocaleSelector/>
        </div>
        <div className={styles.version}>
          {APP_VERSION}
        </div>
      </div>
    </CenteredPublicPage>
  );
});
